import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap'
import './VirtualTourModalDetails.scss'
import getVideoId from 'get-video-id';

const VirtualTourModalDetails = (props) => {
    const [show, setShow] = useState(false);
    const [vUrl, setVUrl] = useState('');
    const videotourid = getVideoId(props.videourl);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    useEffect(() => {        
        if(props.videourl.includes("youtu")){        
            setVUrl("https://www.youtube.com/embed/"+videotourid.id+"?playlist="+videotourid.id+"&loop=1");
        } else {
            setVUrl(props.videourl);
        }
    }, []);   
    
    return (
        <>
            {props.icon ?
                <a href="javascript:void(0)" onClick={handleShow}>
                    <i className="icon-camera"></i>
                    { props.image_count ? <span>{props.image_count}</span> : '' }
                </a>
            :
                <a href="javascript:void(0)" onClick={handleShow} className="tag">
                    Virtual Tour
                </a>
            }

            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={true}
                centered
                size="lg"
                dialogClassName="virtualtour-large-modal"
                className="virtualtour_modal"
            >
                <Modal.Header closeButton>
                </Modal.Header>
                    <Modal.Body className="text-center">
                        <iframe src={vUrl}></iframe>
                    </Modal.Body>
            </Modal>
        </>
    );
}

export default VirtualTourModalDetails;